import React, { useState } from 'react';
import { 
  ContactSection, 
  Container, 
  Title, 
  Subtitle, 
  ContactContent, 
  ContactForm, 
  FormGroup,
  FormLabel,
  FormInput, 
  FormTextarea,
  MapCard,
  MapTitle,
  MapContainer,
  MapIframe,
  MapOverlay,
  MapInfo
} from './Contacts.styles';
import Button from '../Button';

const Contacts = () => {
  const [focusedFields, setFocusedFields] = useState({
    name: false,
    email: false,
    subject: false,
    message: false
  });

  const handleFocus = (fieldName) => {
    setFocusedFields(prev => ({
      ...prev,
      [fieldName]: true
    }));
  };

  const handleBlur = (fieldName, value) => {
    if (!value) {
      setFocusedFields(prev => ({
        ...prev,
        [fieldName]: false
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Gérer la soumission du formulaire ici
    console.log('Formulaire soumis');
  };

  return (
    <ContactSection>
      <Container>
        <Title>Contactez-nous</Title>
        <Subtitle>
          Blessing welcomed ladyship she met humoured sir breeding her. Six curiosity day assurance bed necessary.
        </Subtitle>

        <ContactContent>
          {/* Formulaire */}
          <ContactForm onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel focused={focusedFields.name}>Nom</FormLabel>
              <FormInput 
                type="text" 
                placeholder={focusedFields.name ? "" : "Nom"}
                onFocus={() => handleFocus('name')}
                onBlur={(e) => handleBlur('name', e.target.value)}
              />
            </FormGroup>
            
            <FormGroup>
              <FormLabel focused={focusedFields.email}>Email</FormLabel>
              <FormInput 
                type="email" 
                placeholder={focusedFields.email ? "" : "Email"}
                onFocus={() => handleFocus('email')}
                onBlur={(e) => handleBlur('email', e.target.value)}
              />
            </FormGroup>
            
            <FormGroup>
              <FormLabel focused={focusedFields.subject}>Objet</FormLabel>
              <FormInput 
                type="text" 
                placeholder={focusedFields.subject ? "" : "Objet"}
                onFocus={() => handleFocus('subject')}
                onBlur={(e) => handleBlur('subject', e.target.value)}
              />
            </FormGroup>
            
            <FormGroup>
              <FormLabel focused={focusedFields.message}>Message</FormLabel>
              <FormTextarea 
                placeholder={focusedFields.message ? "" : "Message"} 
                rows="5"
                onFocus={() => handleFocus('message')}
                onBlur={(e) => handleBlur('message', e.target.value)}
              />
            </FormGroup>
            
            <Button type="submit">Envoyer message</Button>
          </ContactForm>

          {/* Map Card */}
          <MapCard>
            <MapTitle>Notre localisation</MapTitle>
            <MapContainer>
              <MapIframe 
                src="https://maps.google.com/maps?q=OlaSoft%2C%20Cotonou%2C%20B%C3%A9nin&t=&z=15&ie=UTF8&iwloc=&output=embed" 
                allowFullScreen 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
              />
              <MapOverlay>
                <i className="fas fa-map-marker-alt"></i>
                OlaSoft, Cotonou
              </MapOverlay>
            </MapContainer>
            <MapInfo>
              Nous sommes situés au cœur de Cotonou, facilement accessible depuis tous les quartiers.
            </MapInfo>
          </MapCard>
        </ContactContent>
      </Container>
    </ContactSection>
  );
};

export default Contacts;